module.exports = __webpack_public_path__ + "img/yaoguo.8a79c102.png";